import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_URL } from '../../utils/api';
import './Leagues.css';

/**
 * Season MVP board: players ranked by HLTV rating, aggregated from the season's
 * recorded league matches (server-side). Hidden until at least one coupled match
 * has demo-derived stats, so manually-scored seasons simply don't show it. Rows
 * link to the player profile.
 *
 * @param {object} props - Component props.
 * @param {string} props.seasonId - The season whose player stats to show.
 */
export default function SeasonPlayerStats({ seasonId }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!seasonId) {
      setRows([]);
      return;
    }
    let active = true;
    fetch(`${API_URL}/api/leagues/seasons/${seasonId}/player-stats`)
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => active && setRows(Array.isArray(d) ? d : []))
      .catch(() => active && setRows([]));
    return () => {
      active = false;
    };
  }, [seasonId]);

  if (rows.length === 0) return null;

  return (
    <div className="league-mvp">
      <h2 className="league-section-title">{t('leagues.playerStats')}</h2>
      <table className="standings-table mvp-table">
        <thead>
          <tr>
            <th className="col-rank">#</th>
            <th className="col-name">{t('nav.players')}</th>
            <th className="col-num">M</th>
            <th className="col-num">K/D</th>
            <th className="col-num">ADR</th>
            <th className="col-num">HS%</th>
            <th className="col-num col-points">Rating</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((p, i) => (
            <tr
              key={p.steam_id}
              className="standings-row is-clickable"
              onClick={() => navigate(`/stats/players/${p.steam_id}`)}
            >
              <td className="col-rank">{i + 1}</td>
              <td className="col-name">{p.name}</td>
              <td className="col-num">{p.matches}</td>
              <td className="col-num">{p.kd}</td>
              <td className="col-num">{p.adr}</td>
              <td className="col-num">{p.hs_pct}%</td>
              <td className="col-num col-points">{p.rating}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
